/* eslint-disable camelcase */
import React, { useState } from 'react'
import { Box, IconButton, Typography } from '@material-ui/core'
import GetAppIcon from '@material-ui/icons/GetApp';
import { postPqrsFiles } from '@auteco/services/finderServices';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import { dateToLocal } from '@auteco/utils/dateToLocal';
import useStyles from './styles'

const Note = ({ note }) => {
    const [showFiles, setShowFiles] = useState(false)
    const classes = useStyles()

    const signFile = async ({ url }) => {
        const body = {
            attachment_url: url
        }
        const { attachment_url } = await postPqrsFiles({ params: body })
        if (attachment_url !== '') {
            const stringSplit = attachment_url.split('?')
            const decodedUrl = decodeURIComponent(stringSplit[1]);
            const concat = `${stringSplit[0]}?${decodedUrl}`
            window.open(concat, '_blank');
        }
    }

    const filesNoEmpty = note.attachments.some(objeto => Object.keys(objeto).length > 0);
    return (
        <div className={classes.note}>
            <Typography><span className={classes.title}>Contenido:</span> {note.body}</Typography>
            <Typography><span className={classes.title}>Id:</span> {note.id}</Typography>
            <Typography><span className={classes.title}>Fecha de creación:</span> {dateToLocal(note["created-at"]).formattedDateAndHour}</Typography>
            <Typography><span className={classes.title}>Fecha de actualización:</span> {dateToLocal(note["updated-at"]).formattedDateAndHour}</Typography>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography><span className={classes.title}>Adjuntos:</span></Typography>
                {filesNoEmpty &&
                    <IconButton style={{ height: '32px', width: '32px' }} onClick={() => setShowFiles(prev => !prev)}>
                        {showFiles ? <ArrowDropUp /> : <ArrowDropDown />}
                    </IconButton>
                }
            </div>
            <Box className={classes.filesContainer}>
                {note.attachments.map(file => (
                    Object.keys(file).length > 0 && showFiles &&
                    <div className={classes.fileContainer}>
                        <Typography><span className={classes.title}>Nombre: </span>{file["content-file-name"]}</Typography>
                        <IconButton onClick={() => signFile({ url: file.attachment_url })} ><GetAppIcon /></IconButton>
                    </div>
                ))
                }
            </Box>
        </div >
    )
}

export { Note }